import { Sensor } from '../sensor/sensor';
export class Alarma {
	_id: string;
	sensor_id: any;
	descripcion: string;
	valorMinimo: Number;
	valorMaximo: Number;
	valorMinimoAmarillo: Number;
	valorMaximoAmarillo: Number;
	alarmaActivada: string;
	avisosLista: any;
	estado: boolean;
	sucursal_id: string;
    repeatable: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/alarmas/alarma.ts